<template>
    <AuthLayout>
        <div class="md:py-12 md:px-8 w-full max-w-lg p-6 mx-auto bg-white border rounded-lg shadow-sm">
            <h2 class="mt-0 mb-8 text-2xl font-bold leading-9 tracking-tight text-center text-gray-700">
                {{ $t('auth.create_a_new_account') }}
            </h2>
            <template v-if="invitationToken">
                <template v-if="invitation">
                    <template v-if="invitation.organization_id">
                        <FormCreateAccount
                            :organization-id="invitation.organization.id"
                            :creator-persona="creatorPersona"
                            :invitation="invitation">
                        </FormCreateAccount>
                    </template>
                    <template v-else>
                        <FormCreateOrganization
                            v-if="currentStep === 2"
                            :organization-name="organizationName"
                            :creator-persona="creatorPersona"
                            :creator-personas="creatorPersonas"
                            :invitation="invitation">
                        </FormCreateOrganization>
                        <FormCreateAccount
                            v-else-if="currentStep === 3"
                            :organization-id="invitation.organization_id"
                            :organization-name="organizationName"
                            :creator-persona="creatorPersona"
                            :invitation="invitation">
                        </FormCreateAccount>
                    </template>
                </template>
                <template v-else>
                    <InvitationLinkError />
                </template>
            </template>
            <template v-else>
                <FormSelectOrganizationOption
                    v-if="currentStep === 1">
                </FormSelectOrganizationOption>
                <FormFindOrganization
                    v-else-if="currentStep === 2 && hash === 'find'">
                </FormFindOrganization>
                <FormCreateOrganization
                    v-else-if="currentStep === 2 && hash === 'create'"
                    :organization-name="organizationName"
                    :creator-persona="creatorPersona"
                    :creator-personas="creatorPersonas"
                    :invitation="invitation">
                </FormCreateOrganization>
                <FormCreateAccount
                    v-else-if="currentStep === 3"
                    :organization-id="organizationId"
                    :organization-name="organizationName"
                    :creator-persona="creatorPersona"
                    :invitation="invitation">
                </FormCreateAccount>
            </template>
        </div>
        <p class="max-w-lg mt-10 text-sm text-center text-gray-600">
            {{ $t('auth.already_have_an_account_cta') }}
            {{ ' ' }}
            <a href="/login" class="font-medium text-blue-500">
                {{ $t('auth.login') }}
            </a>
        </p>
    </AuthLayout>
</template>

<script>
import AuthLayout from '../layouts/AuthLayout.vue';
import FormSelectOrganizationOption from './partials/form-select-organization-option';
import FormCreateOrganization from './partials/form-create-organization.vue';
import FormFindOrganization from './partials/form-find-organization.vue';
import FormCreateAccount from './partials/form-create-account.vue';
import InvitationLinkError from './partials/invitation-link-error.vue';

export default {
    components: {
        AuthLayout,
        FormSelectOrganizationOption,
        FormFindOrganization,
        FormCreateOrganization,
        FormCreateAccount,
        InvitationLinkError,
    },

    props: {
        creatorPersonas: {
            type: Object,
            required: true,
        },
        invitationToken: {
            type: String,
            required: false,
        },
        invitation: {
            type: Object,
            required: false,
        },
    },

    data() {
        return {
            hash: window.location.hash.substring(1),
            steps: 3,
            currentStep: this.getInitialCurrentStep(),
            organizationId: null,
            organizationName: null,
            creatorPersona: null,
        };
    },

    created() {
        window.addEventListener('popstate', () => {
            const hash = window.location.hash.substring(1);
            this.broadcastHashChange(hash);
        });

        Bus.$on('changeScreen', ({ hash, step, organizationId = null, organizationName = null, creatorPersona = null }) => {
            this.setHash(hash);
            this.setStep(step);
            this.setOrganizationData(organizationId, organizationName, creatorPersona);
        });
    },

    methods: {
        setHash(hash) {
            window.history.pushState(null, null, `#${hash}`);
            this.broadcastHashChange(hash);
        },

        broadcastHashChange(hash) {
            this.hash = hash;
        },

        getInitialCurrentStep() {
            if (this.invitationToken) {
                if (this.invitation) {
                    if (this.invitation.organization_id === null) {
                        return 2;
                    }
                }
            }

            const currentStep = ['find', 'create'].includes(window.location.hash.substring(1)) ? 2 : 1;
            return currentStep;
        },

        setStep(step) {
            this.currentStep = step;
        },

        setOrganizationData(organizationId, organizationName, creatorPersona) {
            if (!['find', 'create'].includes(this.hash)) {
                this.organizationId = this.organizationName = this.creatorPersona = null;
                return;
            }

            this.organizationId = (this.hash === 'find') ? organizationId : null;
            this.organizationName = (this.hash === 'create') ? organizationName : null;
            this.creatorPersona = (this.hash === 'create') ? creatorPersona : null;
        },
    },
};
</script>
